module.exports = __webpack_public_path__ + "static/img/miles_pictgrid1_800x738.af6772c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/miles_pictgrid1_800x738.jpg
// module id = t2tU
// module chunks = 0